import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { PaymentCheckoutWizardModule } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { FeaturesService, PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { IconComponent } from '@shared/icon/icon.component';
import { getMe } from '@store/reducers/profile.reducer';
import { Collection, User } from 'lingo2-models';
import { FormatPipeModule } from 'lingo2-ngx-date-fns';
import { ClipboardModule } from 'ngx-clipboard';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiButtonModule, OnUiButtonState, OnUiCoverModule, OnUiTextareaModule } from 'onclass-ui';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-collection-review-form',
  standalone: true,
  imports: [
    CommonModule,
    ClipboardModule,
    TranslateModule,
    FormatPipeModule,
    FormsModule,
    ModalModule,
    PaymentCheckoutWizardModule,
    OnUiButtonModule,
    IconComponent,
    OnUiCoverModule,
    OnUiTextareaModule,
  ],
  templateUrl: './collection-review-form.component.html',
  styleUrls: ['./collection-review-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionReviewFormComponent extends ChangableComponent implements OnInit {
  @Input() public set collectionReview(review: Collection) {
    if (review) {
      this._collectionReview = review;
      this.prepareCard();
    }
  }
  public get collectionReview(): Collection {
    return this._collectionReview;
  }

  public submitState: OnUiButtonState = 'default';
  public me: User;

  private _collectionReview: Collection;

  constructor(
    public errorNotificationService: ErrorNotificationService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
    private router: Router,
    private features: FeaturesService,
    private store: Store,
    private elementRef: ElementRef,
    public deviceService: DeviceDetectorService,
  ) {
    super(cdr);
  }

  ngOnInit() {
    this.store
      .select(getMe)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (me) => {
          this.me = me;
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public get isMe(): boolean {
    return true;
  }

  protected prepareCard() {}

  public get isRated(): boolean {
    return false;
  }

  public setRating(key: string, value: number) {
    this.detectChanges();
  }

  public submit() {}
}
